
import React from "react";

export function UnitSizeFormatter(cellContent, row){

    return (
        <span className="">
            {   
                row.defaultUnitOfMeasurement ? 
                    `${row.defaultUnitOfMeasurement.name} (${row.defaultUnitOfMeasurement.conversionFactor} EA)` :
                    `${row.unitSize || ''} / ${row.unitMeasurement || ''}`
            }
        </span>
    )
}